export class District {
  id: string;
  name: string;
  domains: string[];
  service_expires: Date;
  disabled: boolean;
  max_active_students: Number;
  data_path: string;
}
